import styles from './ExportAllModal.module.scss';
import { useState } from 'react';
import {
    CloseCircleOutlined,
    CloseOutlined,
    DownOutlined,
    ExclamationCircleOutlined,
    FileOutlined,
    LoadingOutlined,
    UpOutlined,
} from '@ant-design/icons';
import { Button, Modal, Tooltip } from 'antd';

const { confirm } = Modal;

const ExportAllModal = props => {
    const { downloadFileList, onExportCancel, onClose } = props;

    const [isExpanded, setIsExpanded] = useState(true);
    const [hoveredItem, setHoveredItem] = useState(null);

    const toggleExpanded = () => {
        setIsExpanded(prev => !prev);
    };

    if (!downloadFileList.length) return null;

    return (
        <div
            className={styles.modalRoot}
            style={{ width: `calc(100vw - ${window.innerWidth - document.body.clientWidth}px)` }}
        >
            <div className={styles.modalContainer}>
                <div className={styles.modalHeader}>
                    <div className={styles.modalTitle}>Preparing download</div>
                    <div className={styles.modalActions}>
                        <Tooltip title={isExpanded ? 'Minimize' : 'Maximize'} key={String(isExpanded)}>
                            <Button onClick={toggleExpanded} className={styles.modalButton}>
                                {isExpanded ? <DownOutlined /> : <UpOutlined />}
                            </Button>
                        </Tooltip>
                        <Tooltip title='Close'>
                            <Button
                                onClick={() => {
                                    confirm({
                                        title: 'Cancel all downloads?',
                                        content:
                                            'Your downloads are not complete. Would you like to cancel all ongoing downloads?',
                                        icon: <ExclamationCircleOutlined />,
                                        okText: 'Cancel downloads',
                                        cancelText: 'Continue downloads',
                                        onOk: onClose,
                                        onCancel() {},
                                    });
                                }}
                                className={styles.modalButton}
                            >
                                <CloseOutlined />
                            </Button>
                        </Tooltip>
                    </div>
                </div>

                {isExpanded && (
                    <div className={styles.modalContent}>
                        {downloadFileList.map(({ fileName, id: fileId }) => {
                            const isHovered = hoveredItem === fileId;

                            return (
                                <div
                                    key={fileId}
                                    className={styles.modalProgressRow}
                                    onMouseEnter={() => setHoveredItem(fileId)}
                                    onMouseLeave={() => setHoveredItem(null)}
                                >
                                    <div className={styles.modalProgressInfo}>
                                        <FileOutlined />
                                        <span className={styles.fileName}>{fileName}</span>
                                    </div>
                                    <Tooltip title='Cancel download' placement={'left'}>
                                        <Button
                                            onClick={() => {
                                                confirm({
                                                    title: 'Are you sure to cancel download?',
                                                    icon: <ExclamationCircleOutlined />,
                                                    onOk() {
                                                        onExportCancel(fileId);
                                                    },
                                                    onCancel() {},
                                                });
                                            }}
                                            className={styles.modalButton}
                                        >
                                            {isHovered ? <CloseCircleOutlined /> : <LoadingOutlined />}
                                        </Button>
                                    </Tooltip>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExportAllModal;
